import Markdown from "react-markdown";
import errorIcon from "../../assets/images/error.svg";
import Spinner from "../spinner";
import TypingDot from "../typing-dot";
import Gravatar from "../gravatar";

function ChatMessages({ messages, isLoading }) {
  return (
    <div className="grow space-y-4">
      {messages.map(({ role, message, loading, error }, idx) => (
        <div
          key={idx}
          className={`flex items-start gap-4 py-4 px-3 rounded-xl ${role === "user" ? "bg-indigo-100" : ""}`}
        >
          {role === "user" && <Gravatar />}
          <div>
            <div className="markdown-container">
              {loading && !message ? (
                <Spinner />
              ) : role === "assistant" ? (
                <>
                  <Markdown className="chat-markdown">{message}</Markdown>
                  {
                    // if the last message is loading, show the typing dot
                    idx === messages.length - 1 && loading && <TypingDot />
                  }
                </>
              ) : (
                <div className="whitespace-pre-line" style={{ fontSize: 18 }}>
                  {message}
                </div>
              )}
            </div>
            {error && (
              <div
                className={`flex items-center gap-1 text-sm text-error-red ${message && "mt-2"}`}
              >
                <img className="h-5 w-5" src={errorIcon} alt="error" />
                <span>Error generating the response</span>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default ChatMessages;
